import * as yup from "yup";

export const ValidationSchema = yup.object().shape({
  group: yup.object().required("Bu xana tələb olunur."),
  date: yup
    .string()
    .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    .required("Bu xana tələb olunur."),
  startTime: yup
    .string()
    .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    .required("Bu xana tələb olunur."),
  endTime: yup
    .string()
    .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    .required("Bu xana tələb olunur."),
  room: yup.object().when("type", {
    is: "offline",
    then: (schema) => schema.required("Bu xana tələb olunur."),
    otherwise: (schema) => schema.notRequired(),
  }),
});
